import React, { useEffect, useState } from "react";
import StyleSheetRW from "core/StyleSheetRW";
import { View, Text, Dimensions, ActivityIndicator } from "react-native";
import DateField from "./DateField";
import { TextInput } from "react-native";
import { ScrollView } from "react-native";
import { formatDate } from "src/utils/Date&TimeUtils";
import { get, push, ref, update } from "firebase/database";
import { db } from "@react-native-firebase/database";
import { getLocalStorageItem } from "core/helpers";
import Dialog from "./Dialog";
import { TOTAL_CASUAL_LEAVE, TOTAL_SICK_LEAVE, TYPE_OF_LEAVE, MOBILE_VIEW_WIDTH, MIN_CASUAL_LEAVE, MAX_CASUAL_LEAVE } from "res/constants";
import DropDownField from "./DropDownField";
import { checkLeaveLimit } from "src/utils/TimeOffRequestUtils";
import { DropDownOptionsUnavailabilty } from "src/utils/DropDownOptionsUtils";

interface AddTimeOffRequest {
  onOpen: boolean;
  onClose: () => void;
  fetchTimeOffList: () => void;
  recordEntryDate?: string;
}

const AddTimeOffRequest: React.FC<AddTimeOffRequest> = ({
  onOpen,
  onClose,
  fetchTimeOffList,
  recordEntryDate,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [dialogMessage, setDialogMassage] = useState("");
  const [userName, setUserName] = useState("");
  const [formData, setFormData] = useState({
    startDate: "",
    endDate: "",
    reason: "",
    availability: "Full Day",
    status: "Applied",
    name: userName,
    rejectReason: "",
    isViewedByAdmin: false,
    leaveType: "Casual leaves",
    noOfDays: "0",
    employmentType: "",
    totalhours: "0"
  });
  const [showToast, setShowToast] = useState(false);
  const [loading, setLoading] = useState(false);
  const loggedinUser = getLocalStorageItem("loggedinUser");
  const fetchUserName = async () => {
    if (loggedinUser) {
      const dbRef = ref(db, `profile/${loggedinUser.uid}`);
      const snapshot = await get(dbRef);
      if (snapshot.exists()) {
        setFormData({
          ...formData,
          name: `${snapshot.val().firstName} ${snapshot.val().lastName}` || "",
          employmentType: snapshot.val().employmentType || "",
        });
      }
    }
  };
  useEffect(() => {
    fetchUserName()
    setIsVisible(onOpen);
  }, [onOpen]);

  const handleInputFieldChange = (name: string, value: any) => {
    if (name === "startDate") {
      setFormData({
        ...formData,
        startDate: value,
        endDate: formatDate(value, "YYYY-MM-DD"),
        noOfDays: calculateDays(value, formatDate(value, "YYYY-MM-DD"), formData.availability).toString(),
      });
    } else if (name === "endDate") {
      if (value >= formData.startDate) {
        const calculatedNoOfDays = calculateDays(formData.startDate, value, formData.availability);
        setFormData({
          ...formData,
          endDate: value,
          noOfDays: calculatedNoOfDays.toString(),
        });
      } else {
        setFormData({
          ...formData,
          endDate: value,
          startDate: formatDate(value, "YYYY-MM-DD"),
          noOfDays: calculateDays(value, formatDate(value, "YYYY-MM-DD"), formData.availability).toString(),
        });
      }
    } else if (name === "availability") {
      setFormData({
        ...formData,
        availability: value,
        noOfDays: value === "Specify hours" ? "0" : calculateDays(formData.startDate || "0", formData.endDate || "0", value).toString(),
      });
    } else if (name === "totalhours") {
      let newValue = 0;
      if (value === '') {
        setFormData({
          ...formData,
          [name]: value,
          noOfDays: "0"
        });
        return;
      }
      const numValue = parseInt(value, 10);
      const maxNumber = formData.employmentType === "Full Time" ? 8 : 4;
      if (numValue > 0 && numValue <= maxNumber) {
        newValue = numValue;
      } else {
        setDialogMassage(`Please enter a value between 1 and ${maxNumber}.`)
        setShowToast(true);
        return; // Ignore values out of range
      }
      setFormData({
        ...formData,
        [name]: String(newValue),
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const calculateDays = (startDate: string, endDate: string, availability: string) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const differenceInTime = end.getTime() - start.getTime();
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    let daysCount = Math.ceil(differenceInDays) + 1;
    if (availability !== "Full Day") {
      daysCount = daysCount / 2;
    }

    return daysCount;
  };



  const checkExistingRequests = async (startDate: string, endDate: string) => {
    const dbRef = ref(db, `timeOffRequest/${loggedinUser.uid}`);

    const snapshot = await get(dbRef);

    if (!snapshot.exists()) {
      console.log("No existing requests found.");
      return false;
    }

    const existingRequests = snapshot.val();

    for (const dateKey in existingRequests) {
      const dateRequests = existingRequests[dateKey];
      for (const requestId in dateRequests) {
        const request = dateRequests[requestId];
        if (
          (request.startDate >= startDate && request.startDate <= endDate) ||
          (request.endDate >= startDate && request.endDate <= endDate) ||
          (startDate >= request.startDate && startDate <= request.endDate) ||
          (endDate >= request.startDate && endDate <= request.endDate)
        ) {
          return true;
        }
      }
    }
    return false;
  };

  const handleYearChange = async () => {
    const currentYear = new Date().getFullYear();
    const lastYear = currentYear - 1;

    const dbRef = ref(db, `timeOffRequest/${loggedinUser.uid}`);
    const snapshot = await get(dbRef);

    if (snapshot.exists()) {
      const requests = snapshot.val();
      let usedCasualLeaves = 0;
      let totalCasualLeaves = TOTAL_CASUAL_LEAVE;

      for (const dateKey in requests) {
        const dateRequests = requests[dateKey];
        for (const requestId in dateRequests) {
          const request = dateRequests[requestId];
          const requestYear = new Date(request.startDate).getFullYear();
          if (request.leaveType === "Casual leaves" && requestYear === lastYear) {
            usedCasualLeaves += parseFloat(request.noOfDays);
          }
        }
      }

      const remainingCasualLeaves = Math.min(totalCasualLeaves - usedCasualLeaves, MIN_CASUAL_LEAVE);

      const carryForwardLeaves = Math.min(remainingCasualLeaves, MIN_CASUAL_LEAVE);
      const newTotalCasualLeaves = Math.min(TOTAL_CASUAL_LEAVE + carryForwardLeaves, MAX_CASUAL_LEAVE);

      const newLeaveData = {
        remainingCasualLeaves: newTotalCasualLeaves,
        remainingSickLeaves: TOTAL_SICK_LEAVE
      };

      const profileRef = ref(db, `profile/${loggedinUser.uid}`);
      await update(profileRef, newLeaveData);
    }
  };


  const handleTimeOffRequest = async () => {
    if (
      formData.reason &&
      formData.startDate &&
      formData.endDate &&
      formData.endDate >= formData.startDate
    ) {
      setLoading(true);
      if (formData.employmentType === "") {
          setDialogMassage("Please ask admin to add your employment type");
          setShowToast(true);
          setLoading(false);
          return;
      }
      try {
        const currentYear = new Date().getFullYear();
        const requestYear = new Date(formData.startDate).getFullYear();
        if (currentYear !== requestYear) {
          await handleYearChange();
        }

        const dbRef = ref(db, `timeOffRequest/${loggedinUser.uid}`);
        const snapshot = await get(dbRef);

        if (snapshot.exists()) {
          const currentMonth = new Date(formData.startDate).toISOString().slice(0, 7);
          const totalCasualLeaves = checkLeaveLimit(snapshot.val(), "Casual leaves", formData.noOfDays, formData.totalhours, currentMonth, "month", formData.employmentType);
          const totalSickLeaves = checkLeaveLimit(snapshot.val(), "Sick leaves", formData.noOfDays, formData.totalhours, currentMonth, "month", formData.employmentType);
          console.log(totalCasualLeaves);
/*
  
          if (
            (formData.leaveType === "Casual leaves" && totalCasualLeaves > TOTAL_CASUAL_LEAVE_PER_MONTH) ||
            (formData.leaveType === "Sick leaves" && totalSickLeaves > TOTAL_SICK_LEAVE_PER_MONTH)
          ) {
            const message = formData.leaveType === "Casual leaves"
              ? "You cannot apply for more than 1.8 casual leaves in a month."
              : "You cannot apply for more than 0.5 sick leaves in a month. Please apply for casual leave if you need more.";
            setDialogMassage(message);
            setShowToast(true);
            setLoading(false);
            return;
          }

          if (formData.leaveType === "Sick leaves" && parseFloat(formData.noOfDays) > TOTAL_SICK_LEAVE_PER_MONTH) {
            setDialogMassage("You cannot get more than 0.5 sick leave in one day. Please apply for casual leave.");
            setShowToast(true);
            setLoading(false);
            return;
          }

*/
        }

        const existingRequest = await checkExistingRequests(
          formData.startDate,
          formData.endDate
        );

        if (existingRequest) {
          setDialogMassage("You have already added leave for this date range. Delete the existing request and try again.");
          setShowToast(true);
          setLoading(false);
          return;
        }

        fetchUserName();

        if (loggedinUser) {
          const formattedDate = formatDate(
            recordEntryDate ? recordEntryDate : new Date(),
            "YYYY-MM-DD"
          );
          const dbRef = ref(
            db,
            `timeOffRequest/${loggedinUser.uid}/${formattedDate}`
          );

          await push(dbRef, formData)
            .then((resData: any) => {
              setFormData({
                startDate: "",
                endDate: "",
                reason: "",
                availability: "Full Day",
                status: "Applied",
                name: "",
                rejectReason: "",
                isViewedByAdmin: false,
                leaveType: "Casual leaves",
                noOfDays: "0",
                employmentType: "",
                totalhours: "0"
              });
              setDialogMassage("Request added successfully!");
              setShowToast(true);
              fetchTimeOffList();
            })
            .catch((error) => {
              console.error("Failed to save data:", error);
              setLoading(false);
              setDialogMassage("Failed to add request. Please try again.");
              setShowToast(true);
            });
        }
      } catch (error) {
        console.error("Error adding document: ", error);
        alert("An error occurred. Please try again.");
        setLoading(false);
        setDialogMassage("An error occurred. Please try again.");
        setShowToast(true);
      }
      setLoading(false);
      onClose();
    } else {
      setLoading(false);
      setDialogMassage("Please Enter All fields");
      setShowToast(true);
    }
  };

  const handleOnClose = () => {
    setFormData({
      startDate: "",
      endDate: "",
      reason: "",
      availability: "Full Day",
      status: "Applied",
      name: "",
      rejectReason: "",
      isViewedByAdmin: false,
      leaveType: "Casual leaves",
      noOfDays: "0",
      employmentType: "",
      totalhours: "0"
    });
    onClose();
  }

  const screenWidth = Dimensions.get("window").width;

  return (
    <>
      <Dialog
        message={dialogMessage}
        isDialogVisible={showToast}
        onDialogClose={() => setShowToast(false)}
        confirmText="Close"
      />

      {isVisible && (
        <View style={{ position: "absolute", zIndex: 1, top: 0, left: 0, right: 0, bottom: 0, justifyContent: "center", alignItems: "center", }}>
          <View style={{ flex: 1, width: "100%", overflow: "scroll" }}>
            <ScrollView style={{ ...styles.Container, paddingTop: screenWidth <= MOBILE_VIEW_WIDTH ? "10px" : "20px", }}>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <Text style={styles.heading}>Add New</Text>
                <svg
                  onClick={handleOnClose}
                  style={{ right: 10, position: "absolute", top: 5, cursor: "pointer" }}
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.6488 6.5L12.762 1.38741C13.0793 1.07001 13.0793 0.555414 12.762 0.238046C12.4446 -0.0793487 11.93 -0.0793487 11.6126 0.238046L6.49998 5.35115L1.38741 0.238046C1.07001 -0.0793487 0.555417 -0.0793487 0.238046 0.238046C-0.0793233 0.555441 -0.0793487 1.07004 0.238046 1.38741L5.35116 6.5L0.238046 11.6126C-0.0793487 11.93 -0.0793487 12.4446 0.238046 12.7619C0.555439 13.0793 1.07004 13.0794 1.38741 12.7619L6.49998 7.64882L11.6126 12.7619C11.93 13.0794 12.4446 13.0794 12.7619 12.7619C13.0793 12.4445 13.0793 11.9299 12.7619 11.6126L7.6488 6.5Z"
                    fill="#2F4858"
                  />
                </svg>
              </View>
              <Text style={styles.label}>Type of Leave</Text>
              <DropDownField
                isObjectList={false}
                value={formData.leaveType}
                placeholder="Select a Type"
                bodyStyle={{ marginHorizontal: 0 }}
                options={TYPE_OF_LEAVE}
                onChangeText={(text) => handleInputFieldChange("leaveType", text)}
                isCloseOnSelection={true}
              />
              <Text style={styles.label}>Start Date</Text>
              <DateField
                value={formData.startDate}
                placeholder="MM-DD-YYYY"
                onChangeText={(text) => handleInputFieldChange("startDate", text)}
                label=""
              />
              <Text style={[styles.label, { marginTop: 0 }]}>End Date</Text>
              <DateField
                value={formData.endDate}
                placeholder="MM-DD-YYYY"
                onChangeText={(text) => handleInputFieldChange("endDate", text)}
                label=""
              />
              {formData.availability === "Specify hours" ? (
                <>
                  <Text style={[styles.label, { marginTop: 0 }]}>Total hours</Text>
                  <TextInput
                    style={styles.input}
                    placeholder="Total hours"
                    placeholderTextColor="rgb(136, 158, 147)"
                    onChangeText={(text) => handleInputFieldChange("totalhours", text)}
                    value={formData.totalhours}
                  />
                </>
              ) : (
                <>
                  <Text style={[styles.label, { marginTop: 0 }]}>No of Days</Text>
                  <TextInput
                    style={styles.input}
                    placeholder="No of Days"
                    placeholderTextColor="rgb(136, 158, 147)"
                    onChangeText={(text) => handleInputFieldChange("noOfDays", text)}
                    editable={false}
                    value={formData.noOfDays}
                  />
                </>
              )}
              <Text style={[styles.label, { marginTop: 10 }]}>Reason</Text>
              <TextInput
                style={styles.input}
                placeholder="Enter reason"
                placeholderTextColor="rgb(136,158,147)"
                onChangeText={(text) => handleInputFieldChange("reason", text)}
              />
              <Text style={[styles.label]}>Unavailability</Text>
              <DropDownField
                isObjectList={false}
                value={formData.availability}
                placeholder="Select a Type"
                bodyStyle={{ marginHorizontal: 0 }}
                options={DropDownOptionsUnavailabilty}
                onChangeText={(text) => handleInputFieldChange("availability", text)}
                isCloseOnSelection={true}
              />

              {loading ? (
                <ActivityIndicator
                  size="small"
                  color="#2F4858"
                  style={{ marginTop: 20 }}
                />
              ) : (
                <button
                  onClick={handleTimeOffRequest}
                  style={{ ...styles.button, width: "110px", marginTop: 10 }}
                >
                  Request
                </button>
              )}
            </ScrollView>
          </View>
        </View>
      )}
    </>
  );
};

export default AddTimeOffRequest;

const styles = StyleSheetRW.create(() => ({
  Container: {
    position: "absolute",
    top: "10px",
    padding: 20,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#ffffff",
    borderRadius: 24,
    opacity: 1,
    transition: "opacity 0.3s ease",
    zIndex: 1,
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
    width: "299px",
    alignSelf: "center",
    height: "90%",
  },
  heading: {
    fontFamily: "Outfit",
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
    color: "#333333",
  },
  label: {
    fontFamily: "Outfit",
    fontSize: 14,
    fontWeight: "600",
    textAlign: "left",
    marginTop: 10,
    marginBottom: 5,
    color: "#333333",
  },
  input: {
    height: 45,
    borderRadius: 10,
    paddingHorizontal: 10,
    backgroundColor: "#0000000D",
    marginTop: 3,
  },
  button: {
    backgroundColor: "#2F4858",
    alignSelf: "center",
    borderRadius: 100,
    color: "white",
    fontWeight: "300",
    textAlign: "center",
    borderWidth: 0,
    width: "250px",
    height: "38px",
    cursor: "pointer",
  },
  buttoneStyle: {
    backgroundColor: "#8c9ea2",
    borderRadius: 99,
    fontWeight: "lighter",
    fontSize: "14px",
    color: "white",
    width: "110px",
    height: "37px",
    border: "0",
    cursor: "pointer",
  },
}));
